<div class="container-fluid" *ngIf="!tmp.tableLoading">
  <!--     <div class="card">
        <div class="card-body chard-fakul" >
            <div id="batchDelete" class="custom-datatable vendor-list">
                <div class="order-graph xl-space">
                    <h6>Fakultet grafikda</h6>
                    <div class="ct-4 flot-chart-container">
                        <x-chartist [type]="chartFakul.type" [data]="chartFakul.data" [options]="chartFakul.options">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-body chard-fakul" >
            <div id="batchDelete" class="custom-datatable vendor-list">
                <div class="order-graph xl-space">
                    <h6>Kafedra grafikda</h6>
                    <div class="ct-4 flot-chart-container">
                        <x-chartist class="ov-x-auto" [type]="chartKaf.type" [data]="chartKaf.data" [options]="chartKaf.options">
                        </x-chartist>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-body vendor-table" >
            <div class="card-header">
                <h5>
                  Fakultet
                </h5>
            </div>
            <div id="batchDelete" class="custom-datatable vendor-list">
                    <div class="btn-popup pull-right">
                        <button type="button" class="btn btn-primary" (click)="exportexcel('excelTableFakultet')">Excelga ko'chirib olish</button>
                    </div>
                <div class="table-responsive">
                        <ng2-smart-table 
                            id="excelTableFakultet" 
                            [settings]="fakultetSet" 
                            [source]="fakultet"
                        ></ng2-smart-table>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="card-body vendor-table" >
            <div class="card-header">
                <h5>
                  Kafedra
                </h5>
            </div>
            <div id="batchDelete" class="custom-datatable vendor-list">
                    <div class="btn-popup pull-right">
                        <button type="button" class="btn btn-primary" (click)="exportexcel('excelTableKafedra')">Excelga ko'chirib olish</button>
                    </div>
                <div class="table-responsive">
                        <ng2-smart-table 
                            id="excelTableKafedra" 
                            [settings]="kafedraSet" 
                            [source]="kafedra"
                        ></ng2-smart-table>
                </div>
            </div>
        </div>
    </div> -->
  <div class="card">
    <div class="card-body vendor-table">
      <div class="card-header">
        <h5 *ngIf="!dialog">O'qituvchilar reytingi ro'yhatda</h5>
        <h5 *ngIf="dialog">
          {{ dataService.kafedraDialogData?.title }} reytingi
        </h5>
      </div>
      <div id="batchDelete" class="custom-datatable vendor-list">
        <div class="btn-popup pull-right">
          <button
            *ngIf="!dialog"
            type="button"
            class="btn btn-primary"
            (click)="exportexcel('excelTablePvo')"
          >
            Excelga ko'chirib olish
          </button>
        </div>
        <div class="table-responsive">
          <ng2-smart-table
            id="excelTablePvo"
            [settings]="settings"
            [source]="source"
            (userRowSelect)="onRowSelect($event)"
          ></ng2-smart-table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="lds-wrap" *ngIf="tmp.tableLoading">
  <div class="lds-dual-ring"></div>
</div>
<app-custom-fullscreen-dialog
  *ngIf="isDialogVisible && environment.otm === 'fjsti'"
  [visible]="isDialogVisible"
  (close)="isDialogVisible = false"
>
  <app-teacher-index-view [selectedRow]="selectedRow"></app-teacher-index-view>
</app-custom-fullscreen-dialog>
